import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    submit ({ dispatch }, contactForm) {
      return new Promise((resolve, reject) => {
        axios({
          method: 'POST',
          url: 'sendgrid/submit_contact',
          data: {
            name: contactForm.name,
            email: contactForm.email,
            message: contactForm.message
          },
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          resolve(res)
        })
          .catch(err => {
            reject(err)
          })
      })
    }
  },
  modules: {
  }
})
